import DrawingsGrid from './DrawingsGrid';

export default DrawingsGrid 


// WEBPACK FOOTER //
// ./src/components/grids/WSDCGrid/index.jsx